const DEFAULT_SLUG = 'sudoku-master';

const APPS = [
  {
    slug: 'sudoku-master',
    name: 'Sudoku Master',
    tagline: 'Famous logic puzzles, offline and free, tuned for quick sessions on phones and tablets.',
    playStoreId: 'com.relitygames.sudokux',
    icon: 'img/icons/sudokumaster.png',
    screens: ['img/screens/sudoku-master1.png', 'img/screens/sudoku-master2.png'],
    features: [
      { title: 'Novice to expert', body: 'Over 50,000 puzzles across six difficulty levels for a steady climb in skill.' },
      { title: 'Themes that fit you', body: 'Six curated themes for light and dark play without visual fatigue.' },
      { title: 'Daily challenge', body: 'Track progress over time, learn techniques, and keep a calm solving habit.' },
    ],
  },
  {
    slug: 'image-compressor',
    name: 'Image Compressor',
    tagline: 'Offline photo compressor - batch compress, resize, crop, convert JPG PNG WebP.',
    playStoreId: 'com.relitygames.imagecompressor',
    icon: 'img/icons/imagecompressor.png',
    screens: ['img/screens/imagecompressor1.png', 'img/screens/imagecompressor2.png'],
    features: [
      { title: 'Batch processing', body: 'Process multiple images at once for efficient photo management.' },
      { title: 'Image editing', body: 'Crop, resize, and convert images to JPG, PNG, or WebP formats.' },
      { title: 'Quality control', body: 'Set compression levels and quality settings to match your needs.' },
    ],
  },
  {
    slug: 'get-fit-quick',
    name: 'Get Fit Quick',
    tagline: 'Gym workout plans, exercise library, logging & progress charts - for free.',
    playStoreId: 'com.relitygames.getfit',
    icon: 'img/icons/getfitquick.png',
    screens: ['img/screens/getfit1.png', 'img/screens/getfit2.png'],
    features: [
      { title: 'Quick sessions', body: 'Workouts sized for busy days so consistency stays realistic.' },
      { title: 'Clear coaching', body: 'Visuals and pacing that keep form and effort easy to follow.' },
      { title: 'Build momentum', body: 'Track streaks and celebrate small wins that compound over time.' },
    ],
  },
  {
    slug: 'binary-flow',
    name: 'Binary Flow',
    tagline: 'Focused binary brain puzzles with sizes from 6×6 to 12×12 and relaxed streaks.',
    playStoreId: 'com.relitygames.binaryflow',
    icon: 'img/icons/binaryflow.png',
    screens: ['img/screens/binary2.png', 'img/screens/binary1.png'],
    features: [
      { title: 'Mental workout', body: 'One puzzle at a time keeps sessions light instead of overwhelming.' },
      { title: 'Relaxed routine', body: 'Progress and streaks reward consistency without pressure.' },
      { title: 'Your grid', body: 'Multiple sizes and difficulties so every session matches your mood.' },
    ],
  },
  {
    slug: 'golf-solitaire',
    name: 'Golf Solitaire Classic',
    tagline: 'A polished solitaire twist with classic and endless modes plus global competition.',
    playStoreId: 'com.relitygames.golfsolitaire',
    icon: 'img/icons/golfsolitaire.png',
    screens: ['img/screens/golf1.png', 'img/screens/golf2.png'],
    features: [
      { title: 'Two modes', body: 'Hand-crafted classic rules or an infinite chase for your best run.' },
      { title: 'Quick rounds', body: 'Clean layout and snappy play for coffee-break sessions.' },
      { title: 'Leaderboards', body: 'Statistics and global boards when you want an extra push.' },
    ],
  },
  {
    slug: 'knowledge-quiz',
    name: 'Knowledge Quiz',
    tagline: 'Cross-domain trivia with lifelines and a huge question pool to keep things fresh.',
    playStoreId: 'com.relitygames.knowledgequiz',
    icon: 'img/icons/knowledgequiz.png',
    screens: ['img/screens/quiz1.png', 'img/screens/quiz2.png'],
    features: [
      { title: 'Engaging play', body: 'Test memory and reasoning across varied topics in tight rounds.' },
      { title: '10,000+ questions', body: 'Depth for curious players who like to revisit categories.' },
      { title: 'Strategic lifelines', body: 'Use help wisely when the clock is ticking and stakes feel high.' },
    ],
  },
  {
    slug: 'english-grammar',
    name: 'English Grammar Test',
    tagline: 'Practice paths, exercises, and progress tracking for confident everyday grammar.',
    playStoreId: 'com.relitygames.englishgrammar',
    icon: 'img/icons/englishgrammar.png',
    screens: ['img/screens/english-grammar1.png', 'img/screens/english-grammar2.png'],
    features: [
      { title: 'Tailored learning', body: 'Shape sessions around the topics you actually need to reinforce.' },
      { title: 'Interactive drills', body: 'Large exercise sets spanning core grammar concepts.' },
      { title: 'Visible progress', body: 'Goals and achievements that show momentum week to week.' },
    ],
  },
  {
    slug: 'killer-sudoku',
    name: 'Killer Sudoku',
    tagline: 'Sudoku meets sums cages: deep logic, four difficulties, and thousands of puzzles.',
    playStoreId: 'com.relitygames.killersudoku',
    icon: 'img/icons/killersudoku.png',
    screens: ['img/screens/killer-sudoku1.png', 'img/screens/killer-sudoku2.png'],
    features: [
      { title: 'Hybrid logic', body: 'Blend classic sudoku with kakuro-style cages for fresh constraints.' },
      { title: 'Huge library', body: '10,000+ puzzles spanning four difficulties for long-term play.' },
      { title: 'Daily goals', body: 'Challenges and progress hooks for players who like a steady ritual.' },
    ],
  },
  {
    slug: 'number-rush',
    name: 'Number Rush',
    tagline: 'Minimal merge puzzler built for reflex, focus, and satisfying number chains.',
    playStoreId: 'com.relitygames.numberrush',
    icon: 'img/icons/numberrush.png',
    screens: ['img/screens/rush2.png', 'img/screens/rush1.png'],
    features: [
      { title: 'Easy to start', body: 'Straightforward merge rules with a calm, modern presentation.' },
      { title: 'Deep merges', body: 'Colourful boards that stay readable even as chains grow longer.' },
      { title: 'Mindful focus', body: 'Short rounds that still train memory, concentration, and timing.' },
    ],
  },
  {
    slug: 'sudoku-classic',
    name: 'Sudoku Classic',
    tagline: 'Massive offline library with helpers, fine-grained difficulty, and Play Games sync.',
    playStoreId: 'com.sbox.sudokuclassic',
    icon: 'img/icons/sudokuclassic.png',
    screens: ['img/screens/s1.png', 'img/screens/s2.png'],
    features: [
      { title: 'Truly offline', body: '60,000+ puzzles with full usability when you are off the network.' },
      { title: 'Fine control', body: 'Beginner through evil levels with helpers tuned to your style.' },
      { title: 'Friends and stats', body: 'Statistics plus Google Play Games leaderboards and achievements.' },
    ],
  },
];

function esc(text) {
  const n = document.createElement('div');
  n.textContent = text;
  return n.innerHTML;
}

function playUrl(id) {
  return `https://play.google.com/store/apps/details?id=${encodeURIComponent(id)}`;
}

function getSlug() {
  const raw = (typeof location !== 'undefined' && location.hash ? location.hash : '').slice(1);
  if (!raw) return DEFAULT_SLUG;
  return APPS.some((a) => a.slug === raw) ? raw : DEFAULT_SLUG;
}

function appBySlug(slug) {
  return APPS.find((a) => a.slug === slug) || APPS[0];
}

function renderGrid(activeSlug) {
  const grid = document.getElementById('app-grid');
  if (!grid) return;
  grid.innerHTML = '';
  const frag = document.createDocumentFragment();
  for (const app of APPS) {
    const a = document.createElement('a');
    a.href = `#${app.slug}`;
    a.role = 'listitem';
    a.className = [
      'group flex gap-4 rounded-xl border p-4 text-left transition',
      app.slug === activeSlug
        ? 'border-brand-500/60 bg-brand-500/10 shadow-glow ring-1 ring-brand-400/40'
        : 'border-slate-800 bg-slate-900/40 hover:border-brand-500/35 hover:bg-slate-900',
    ].join(' ');
    a.innerHTML = `
      <span class="relative shrink-0">
        <img src="${app.icon}" alt="" width="56" height="56" class="h-14 w-14 rounded-2xl border border-slate-700/80 bg-slate-800 object-cover shadow-md transition group-hover:border-brand-400/40" />
      </span>
      <span class="min-w-0 flex-1">
        <span class="block font-semibold text-white group-hover:text-brand-100">${esc(app.name)}</span>
        <span class="mt-1 min-w-0 max-w-full line-clamp-2 break-words text-sm leading-snug text-slate-400">${esc(app.tagline)}</span>
        <span class="mt-2 inline-flex items-center text-xs font-medium text-brand-300">View details</span>
      </span>
    `;
    frag.appendChild(a);
  }
  grid.appendChild(frag);
}

function renderDetail(slug) {
  const mount = document.getElementById('app-detail');
  if (!mount) return;
  const app = appBySlug(slug);
  const feats = app.features
    .map(
      (f) => `
    <li class="rounded-2xl border border-white/[0.06] bg-white/[0.03] px-4 py-4 backdrop-blur-sm transition hover:border-white/[0.1] hover:bg-white/[0.05] sm:px-5 sm:py-4">
      <span class="block border-l-2 border-brand-400/70 pl-4">
        <span class="font-medium text-white">${esc(f.title)}</span>
        <span class="mt-1.5 block text-sm leading-relaxed text-slate-400">${esc(f.body)}</span>
      </span>
    </li>`
    )
    .join('');
  mount.innerHTML = `
    <div id="${app.slug}" class="scroll-mt-24 outline-none" tabindex="-1">
    <div class="flex flex-col overflow-visible lg:flex-row lg:items-stretch">
      <div class="showcase-stage">
        <div class="phone-frame w-[min(42vw,13.5rem)] origin-center -rotate-[4deg] sm:w-[min(40vw,15rem)] lg:w-[min(36vw,17.5rem)] xl:w-[18.5rem]">
          <img src="${app.screens[0]}" alt="${esc(app.name)} screenshot" width="390" height="844" loading="lazy" />
        </div>
        <div class="phone-frame relative z-[11] w-[min(42vw,13.5rem)] origin-center -ml-2 translate-y-3 rotate-[4deg] sm:-ml-3 sm:w-[min(40vw,15rem)] sm:translate-y-4 lg:-ml-4 lg:w-[min(36vw,17.5rem)] xl:w-[18.5rem]">
          <img src="${app.screens[1]}" alt="" width="390" height="844" loading="lazy" />
        </div>
      </div>
      <div class="min-w-0 border-t border-white/[0.06] px-5 py-8 sm:px-8 sm:py-10 lg:flex lg:max-w-xl lg:flex-1 lg:flex-col lg:justify-center lg:border-l lg:border-t-0 lg:py-12 lg:pl-10 lg:pr-12">
        <h2 class="text-2xl font-semibold tracking-tight text-white sm:text-3xl">${esc(app.name)}</h2>
        <p class="mt-3 text-base leading-relaxed text-slate-400">${esc(app.tagline)}</p>
        <ul class="mt-8 flex flex-col gap-3">${feats}</ul>
        <div class="mt-8 text-center">
          <a class="play-btn" href="${playUrl(app.playStoreId)}" target="_blank" rel="noopener noreferrer">
            <img src="img/google-play.svg" alt="" width="28" height="28" />
            <span class="leading-tight">
              <span class="block text-xs text-slate-400">Get it on</span>
              <span class="block text-sm font-semibold text-white">Google Play</span>
            </span>
          </a>
        </div>
      </div>
    </div>
    </div>
  `;
}

function scrollDetailIntoViewFromHash() {
  const raw = typeof location !== 'undefined' && location.hash ? location.hash.slice(1) : '';
  if (!raw || !APPS.some((a) => a.slug === raw)) return;
  const el = document.getElementById(raw);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

function sync() {
  const slug = getSlug();
  renderGrid(slug);
  renderDetail(slug);
  requestAnimationFrame(() => {
    requestAnimationFrame(scrollDetailIntoViewFromHash);
  });
}

function onHashChange() {
  sync();
}

const logoHome = document.getElementById('logo-home');
if (logoHome) {
  logoHome.addEventListener('click', (e) => {
    e.preventDefault();
    history.pushState(null, '', `${location.pathname}${location.search}`);
    sync();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
}

window.addEventListener('hashchange', onHashChange);
sync();
